const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY_ID;

export function isRazorpayConfigured() {
  // Razorpay key is provided server-side by Edge Function (stored in Supabase Secrets)
  // Check that Supabase is configured so Edge Functions can be reached
  return Boolean(
    process.env.REACT_APP_SUPABASE_URL &&
    process.env.REACT_APP_SUPABASE_ANON_KEY
  );
}

export function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

export async function openRazorpayCheckout({
  amount,
  orderNumber,
  razorpayOrderId,
  razorpayKeyId,
  customer,
  onSuccess,
  onDismiss,
}) {
  const key = razorpayKeyId || RAZORPAY_KEY;
  if (!key) {
    throw new Error('Razorpay is not configured. Add REACT_APP_RAZORPAY_KEY_ID to your .env file.');
  }
  if (!razorpayOrderId) {
    throw new Error('Razorpay order ID is missing. Payment must be initiated from the server.');
  }

  const loaded = await loadRazorpayScript();
  if (!loaded) {
    throw new Error('Could not load Razorpay. Check your internet connection.');
  }

  return new Promise((resolve, reject) => {
    const options = {
      key,
      amount: Math.round(amount * 100),
      currency: 'INR',
      order_id: razorpayOrderId,
      name: 'Metameni',
      description: `Order ${orderNumber}`,
      image: '/favicon.ico',
      handler: async (response) => {
        try {
          await onSuccess?.(response);
          resolve(response);
        } catch (err) {
          reject(err);
        }
      },
      prefill: {
        name: customer.name || '',
        email: customer.email || '',
        contact: customer.phone || '',
      },
      notes: {
        order_number: orderNumber,
      },
      theme: {
        color: '#000000',
      },
      modal: {
        ondismiss() {
          onDismiss?.();
          resolve(null);
        },
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.on('payment.failed', (response) => {
      reject(new Error(response.error?.description || 'Payment failed'));
    });
    rzp.open();
  });
}
